import React from "react";
import tablet from "../../assets/tablet.png";
import moublanco from "../../assets/mouBlanco.png";

const Section3 = () => {

    return (
        <div className="flex bg-[#0346a4] text-white items-center justify-between z-2 relative px-60 pt-16 gap-x-10">
            <img src={tablet} alt="Finanzas abiertas" className="rounded-3xl w-96 h-auto object-cover" />
            <img src={moublanco} alt="Meu logo" className="rounded-3xl w-24 self-start mt-[20px]" />
            <div className="max-w-2xl">
                <h2 className="text-5xl font-bold">Comparte tus datos con otras entidades a través de MEU</h2>
                <p className="text-2xl mt-2 text-[#e8f2f4] font-bold mt-12" style={{ textShadow: '2px 2px 10px rgba(0,0,0,0.3)' }}>
                    Desde nuestra app, en MeuBancos, puedes permitirnos acceder a la información de otras entidades, como saldos y movimientos, para gestionar tus finanzas de manera sencilla. Para tu tranquilidad, puedes revocar tu autorización en cualquier momento.
                </p>
              
            </div>
        </div>

    );
};

export default Section3;
